<div class="imageContainer" [ngClass]="{'imageContainer--verDetalle': verCompleta && !sinImagen}" id="imagenDiv{{id}}"
     (click)="VerImagenCompleta()" #imagenDiv>

  <img [id]="'imagen' + id" [src]="imagen  | Imagen | async" class="imageContainer__imagen {{claseAlineacion}}" *ngIf="!sinImagen" [hidden]="!cargada"
       #imagenElemento (load)="ImagenCargada($event)" />

  <img [id]="'sinImagen' + id" [src]="sinImagenSRC  | Imagen | async" *ngIf="sinImagen" class="imageContainer__imagen {{claseAlineacion}}" [hidden]="!cargada"
       (load)="SinImagenCargada()" #sinimagenElemento>

</div>

<imagenCompleta [imagen]="imagen" *ngIf="verCompleta && !sinImagen" #imagenCompleta></imagenCompleta>
